import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2 editor__container" }
const _hoisted_2 = { class: "d-flex align-stretch" }
const _hoisted_3 = { class: "d-flex flex-column editor__container__options" }
const _hoisted_4 = { class: "py-2 mt-4 editor__container" }
const _hoisted_5 = { class: "d-flex align-stretch" }
const _hoisted_6 = { class: "d-flex flex-column editor__container__options" }
const _hoisted_7 = { class: "py-2 mt-4 editor__container" }
const _hoisted_8 = { class: "d-flex align-stretch" }
const _hoisted_9 = { class: "d-flex flex-column editor__container__options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailOptions = _resolveComponent("MailOptions")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field_filled, {
      label: "Objet du mail",
      modelValue: _ctx.mail.header,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mail.header) = $event)),
      outlined: "",
      ref: "headerTextarea",
      density: "compact",
      class: "pb-4"
    }, {
      "append-inner": _withCtx(() => [
        _createVNode(_component_MailOptions, {
          text: _ctx.mail.header,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail.header) = $event)),
          reference: "headerTextarea",
          modelPropertyName: "header",
          startPos: _ctx.getTextareaCursorSelection(_ctx.headerTextarea!).selectionStart,
          endPos: _ctx.getTextareaCursorSelection(_ctx.headerTextarea!).selectionEnd,
          isInvoiceNextDueDate: true,
          onOnMailOptionSelected: _ctx.loadNewCursorHeaderPos
        }, null, 8, ["text", "startPos", "endPos", "onOnMailOptionSelected"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("label", {
        for: "upperBody",
        class: "editor__container__label"
      }, "Corps du mail supérieur", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Editor, {
          modelValue: _ctx.mail.upperBody,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mail.upperBody) = $event)),
          ref: "upperBodyTextarea",
          id: "upperBody",
          class: "flex-grow-1"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_MailOptions, {
            text: _ctx.mail.upperBody,
            "onUpdate:text": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mail.upperBody) = $event)),
            reference: "upperBodyTextarea",
            modelPropertyName: "upperBody",
            onOnMailOptionSelected: _ctx.loadNewCursorUpperBodyPos
          }, null, 8, ["text", "onOnMailOptionSelected"]),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_v_btn_icon, {
              icon: "$fa-redo-alt",
              size: "small",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mail.upperBody = ''))
            }, null, 512), [
              [_directive_tooltip, 'Remettre les valeurs par défauts', "bottom"]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[12] || (_cache[12] = _createElementVNode("label", {
        for: "lineBody",
        class: "editor__container__label"
      }, "Ligne du corps du mail", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Editor, {
          modelValue: _ctx.mail.lineBody,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mail.lineBody) = $event)),
          ref: "lineBodyTextarea",
          id: "lineBody",
          class: "flex-grow-1"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_MailOptions, {
            text: _ctx.mail.lineBody,
            "onUpdate:text": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.mail.lineBody) = $event)),
            reference: "lineBodyTextarea",
            modelPropertyName: "lineBody",
            onOnMailOptionSelected: _ctx.loadNewCursorLineBodyPos
          }, null, 8, ["text", "onOnMailOptionSelected"]),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_v_btn_icon, {
              icon: "$fa-redo-alt",
              size: "small",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mail.lineBody = ''))
            }, null, 512), [
              [_directive_tooltip, 'Remettre les valeurs par défauts', "bottom"]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[13] || (_cache[13] = _createElementVNode("label", {
        for: "lowerBody",
        class: "editor__container__label"
      }, "Corps du mail inférieur", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Editor, {
          modelValue: _ctx.mail.lowerBody,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mail.lowerBody) = $event)),
          ref: "lowerBodyTextarea",
          id: "lowerBody",
          class: "flex-grow-1"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_MailOptions, {
            text: _ctx.mail.lowerBody,
            "onUpdate:text": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.mail.lowerBody) = $event)),
            reference: "lowerBodyTextarea",
            modelPropertyName: "lowerBody",
            onOnMailOptionSelected: _ctx.loadNewCursorLowerBodyPos
          }, null, 8, ["text", "onOnMailOptionSelected"]),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_v_btn_icon, {
              icon: "$fa-redo-alt",
              size: "small",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.mail.lowerBody = ''))
            }, null, 512), [
              [_directive_tooltip, 'Remettre les valeurs par défauts', "bottom"]
            ])
          ])
        ])
      ])
    ])
  ]))
}